var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{staticClass:"clearfix",attrs:{"name":"fade"}},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"notification",class:_vm.classObj},[_vm._v("\n        "+_vm._s(_vm.message)+"\n        ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53fe0ae2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Notifications.vue
// module id = VGM0
// module chunks = 0